import {
  jb_contact_icon_css_default
} from "./chunk.FXRSGYY7.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Icon
} from "./chunk.RCJUEYAG.js";
import {
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/icons/jb-contact-icon/jb-contact-icon.ts
var JbContactIcon = class extends Icon(r) {
  render() {
    return ke`
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.50289 7.28883C2.50289 2.93905 5.40794 2 7.0746 2L9.8421 7.28883L7.0746 10.2005C8.39792 14.0195 9.85577 15.6897 13.8446 17.4876L16.6719 14.5465L21.6703 17.4876C21.5596 18.9496 21.3115 21.6144 17.1933 22.0145C10.7511 22.3819 2.32126 14.5465 2.50289 7.28883Z"
          stroke="currentColor"
          stroke-linejoin="round"
          fill="none"
          stroke-width="1.2"
        />
      </svg>
      <slot></slot>
    `;
  }
};
JbContactIcon.styles = [reset_css_default, jb_contact_icon_css_default];
JbContactIcon = __decorateClass([
  customElement("jb-contact-icon")
], JbContactIcon);

export {
  JbContactIcon
};
